const forList = [
  'Tu veux apprendre à investir en Bourse de façon autonome',
  'Tu cherches un revenu complémentaire passif chaque mois',
  'Tu veux construire un patrimoine sur le long terme',
  'Tu es débutant(e) ou investisseur intermédiaire',
  'Tu veux comprendre les marchés financiers en profondeur',
];

const notForList = [
  'Tu cherches à t\'enrichir du jour au lendemain',
  'Tu n\'es pas prêt(e) à t\'investir dans ta formation',
  'Tu veux du trading court terme spéculatif',
  'Tu cherches quelqu\'un qui gère tes finances à ta place',
];

const ForWhoSection = () => (
  <section className="bg-white py-16 px-8 lg:px-16">
    <div className="max-w-[1272px] mx-auto">
      <h2 className="text-[#1E0750] font-black text-3xl lg:text-4xl text-center mb-10">
        Est-ce que cette Méthode<br />
        <span className="text-[#7B35ED]">est faite pour toi ?</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* For */}
        <div className="bg-[#F0FFF0] border border-[#A3E635]/40 rounded-2xl p-7">
          <h3 className="text-[#1E0750] font-black text-lg mb-5 flex items-center gap-2">
            <span className="w-7 h-7 flex items-center justify-center bg-[#A3E635] rounded-full">
              <i className="ri-check-line text-[#1E0750] text-sm" />
            </span>
            C&apos;est fait pour toi si...
          </h3>
          <ul className="space-y-3">
            {forList.map((item, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-[#1E0750]">
                <i className="ri-check-line text-[#A3E635] flex-shrink-0 mt-0.5 text-base" />
                {item}
              </li>
            ))}
          </ul>
        </div>
        {/* Not for */}
        <div className="bg-[#FFF5F5] border border-red-200 rounded-2xl p-7">
          <h3 className="text-[#1E0750] font-black text-lg mb-5 flex items-center gap-2">
            <span className="w-7 h-7 flex items-center justify-center bg-red-400 rounded-full">
              <i className="ri-close-line text-white text-sm" />
            </span>
            Ce n&apos;est pas pour toi si...
          </h3>
          <ul className="space-y-3">
            {notForList.map((item, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-[#1E0750]">
                <i className="ri-close-line text-red-400 flex-shrink-0 mt-0.5 text-base" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default ForWhoSection;
